import {
  browserLocalPersistence,
  browserSessionPersistence,
  getAuth,
  indexedDBLocalPersistence,
  initializeAuth,
} from 'firebase/auth'
import app from '~/src/lib/firebase/firebaseApp'

export const auth =
  typeof window === 'undefined'
    ? getAuth(app)
    : (() => {
        try {
          // Defer the auth iframe until popup sign-in; this mirrors getAuth's
          // default persistence order so existing sessions continue to work.
          return initializeAuth(app, {
            persistence: [
              indexedDBLocalPersistence,
              browserLocalPersistence,
              browserSessionPersistence,
            ],
          })
        } catch {
          // initializeAuth throws when HMR or another module initialized it first.
          return getAuth(app)
        }
      })()
